// SEC-06: silences console.log/debug/info in production ON IMPORT, so it is in force
// before any module below logs while it is being evaluated. Credential logging is removed
// at source; this covers the remaining ~580 calls and whatever is added next.
import "./Util/silenceConsole";
// Must stay the FIRST imports after that: hubSession wraps axios/fetch before any module
// creates an instance, and hubSessionConfig sets VT-FE options (agent vs public session)
// before any hub call. Hub calls then carry a server-issued session, never a bundled token.
import "./Util/hubSession";
// AUTH-04: a 401 from VT-Backend now ends the session and asks for a sign-in, instead of
// being swallowed by four commented-out interceptors. Hub 401s stay with hubSession.
import "./Util/authInterceptor";
import "./Util/hubSessionConfig";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import Modal from 'react-modal';
require('react-web-vector-icons/fonts');


const token = localStorage.getItem("jToken");

if (token === null) {
  document.body.classList.add("token-present");
  document.body.classList.remove("no-token");
} else {
  document.body.classList.add("no-token");
  document.body.classList.remove("token-present");
}

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
